<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div :class="{ card: !embedded }">
        <h4 v-if="!embedded">Bank Holidays</h4>
        <p v-if="!embedded">No follow-up email is sent on these days; one that falls due waits for the next working day.</p>

        <div class="p-mb-4 p-d-flex p-jc-between p-toolbar">
          <Button
            label="New Bank Holiday"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            style="margin-right: 1em"
            @click="openNew"
          />
        </div>

        <BankHolidaysTable
          :key="'BankHolidaysTable' + tableKey"
          :holidays="holidays"
          :loading="requesting"
          @edit-holiday="editHoliday"
          @delete-holiday="askDelete"
        />

        <BankHolidayForm
          :key="'BankHolidayForm' + formKey"
          :holidayToEdit="holiday"
          :holidayForm="holidayForm"
          :serverErrors="serverErrors"
          @close="hideForm"
          @save="saveHoliday"
        />

        <Dialog :visible.sync="deleteDialog" header="Delete bank holiday" :modal="true" :style="{ width: '420px' }">
          <p v-if="toDelete">Delete {{ toDelete.name }} ({{ displayDate(toDelete.holidayDate) }})?</p>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteDialog = false" />
            <Button label="Yes, delete" icon="pi pi-check" class="p-button-text p-button-danger" @click="confirmDelete" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import FollowupService, { errorMessage, fieldErrors } from '@/service/FollowupService'
import BankHolidaysTable from './bankHolidaysTable'
import BankHolidayForm from './bankHolidayForm'
import { displayDate } from './bankHolidayDates'

export default {
  // P6: shown inside a Follow-up Settings tab, which gives the title and explanation
  props: {
    embedded: { type: Boolean, default: false }
  },
  components: { BankHolidaysTable, BankHolidayForm },
  data: () => ({
    followupService: new FollowupService(),
    holidays: [],
    holiday: {},
    holidayForm: false,
    serverErrors: {},
    tableKey: 0,
    formKey: 0,
    requesting: false,
    deleteDialog: false,
    toDelete: null
  }),
  created() {
    this.getHolidays()
  },
  methods: {
    displayDate,
    getHolidays() {
      this.requesting = true
      return this.followupService.getBankHolidays()
        .then(data => {
          this.holidays = data || []
          this.tableKey++
        })
        .catch(err => {
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: errorMessage(err, 'Some data was not loaded from "bankHolidays"')
          })
        })
        .finally(() => { this.requesting = false })
    },
    openNew() {
      this.holiday = {}
      this.serverErrors = {}
      this.holidayForm = true
      this.formKey++
    },
    editHoliday(holiday) {
      this.holiday = holiday
      this.serverErrors = {}
      this.holidayForm = true
      this.formKey++
    },
    hideForm() {
      this.holiday = {}
      this.holidayForm = false
    },
    saveHoliday(holiday) {
      var call = holiday.id ? this.followupService.editBankHoliday(holiday) : this.followupService.saveBankHoliday(holiday)
      return call
        .then(() => {
          this.$toast.add({ severity: 'success', summary: 'Bank holiday saved', detail: holiday.name + ' was saved.', life: 5000 })
          this.holidayForm = false
          this.getHolidays()
        })
        .catch(err => {
          this.serverErrors = fieldErrors(err)
          this.$toast.add({ severity: 'error', summary: 'Not saved', detail: errorMessage(err, 'The bank holiday could not be saved.'), life: 5000 })
        })
    },
    askDelete(holiday) {
      this.toDelete = holiday
      this.deleteDialog = true
    },
    confirmDelete() {
      var holiday = this.toDelete
      this.deleteDialog = false
      return this.followupService.deleteBankHoliday(holiday.id)
        .then(() => {
          this.$toast.add({ severity: 'success', summary: 'Bank holiday deleted', detail: holiday.name + ' was deleted.', life: 5000 })
          this.getHolidays()
        })
        .catch(err => {
          this.$toast.add({ severity: 'error', summary: 'Not deleted', detail: errorMessage(err, 'The bank holiday could not be deleted.'), life: 5000 })
        })
    }
  }
}
</script>

<style></style>
